import axios from "fetch-api/fetch-api";
import { IOrdersCount } from "../interfaces/account.type";

export function getOrdersCountApi() {
  return axios.post<IOrdersCount>("/get-orders-count", {});
}
